import { defineStore } from 'pinia';
import { useAuthStore } from '@src/stores/auth.js';

export const useAppStore = defineStore('appStore', {
    state: () => ({
        initialized: false,
        loading: true,
        isInIframe: false
    }),

    actions: {
        async initialize() {
            const authStore = useAuthStore();
            await authStore.fetchUser();

            this.checkIframe();
            this.initialized = true;
            this.loading = false;
        },

        getProductUrl(address) {
            const base = import.meta.env.VITE_FRONTEND_ADDRESS.replace(/\/+$/, '');
            return `${base}/produkt/${address}`;
        },

        getCategoryUrl(address) {
            const base = import.meta.env.VITE_FRONTEND_ADDRESS.replace(/\/+$/, '');
            return `${base}/kategoria/${address}`;
        },

        checkIframe() {
            try {
                const qp = new URLSearchParams(window.location.search).get('iframe');
                if (qp === 'true') {
                    this.isInIframe = true;
                } else if (qp === 'false') {
                    this.isInIframe = false;
                } else {
                    this.isInIframe = window.self !== window.top;
                }
            } catch (e) {
                this.isInIframe = true;
            }
        }
    }
});
